import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { NgClass, NgOptimizedImage } from '@angular/common';
import { AuthService } from '../auth/auth.service';
import { assetUrl } from '@app/shared/utils/asset-url.util';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  imports: [FormsModule, NgOptimizedImage, NgClass, RouterLink],
})
export class LoginComponent implements OnInit {
  credentials = { email: '', password: '' };

  protected error?: string = undefined;
  // TVG-333: why a quote email link sent the customer here instead of home.
  protected notice?: string = undefined;
  protected loggingIn = false;
  protected showPassword = false;
  protected rememberMe = false;
  protected readonly logoUrl = assetUrl('images/the-venue-group-logo.svg');

  constructor(
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  /**
   * TVG-333: a quote email link whose customer already has a password sends
   * them here with their email filled in. The notice also covers a password
   * they have forgotten, without saying anything about other accounts.
   */
  ngOnInit(): void {
    const params = this.route.snapshot.queryParamMap;
    const email = params.get('email');
    if (email) {
      this.credentials.email = email;
    }
    if (params.get('reason') === 'password_required') {
      this.notice = 'You have set a password, so please sign in with it to see your quotes. If you have forgotten it, use Forgot password to set a new one.';
    }
  }

  login() {
    this.error = undefined;
    this.loggingIn = true;

    this.authService.getCsrfCookie().subscribe({
      next: (csrf) => {
        this.authService.login(this.credentials).subscribe({
          next: (response) => {
            // VG-380: Fetch user to determine role-based redirect
            this.authService.fetchUser().subscribe({
              next: (user) => {
                // VG-380 / VG-65: Redirect customers to customer portal.
                // TVG-170: the combined home is the single client landing page.
                if (user.roles?.includes('customer')) {
                  this.router.navigate(['/my-home']);
                } else {
                  this.router.navigate(['/events']);
                }
              },
              error: () => {
                // Fallback to events if user fetch fails
                this.router.navigate(['/events']);
              }
            });
          },
          error: (response) => {
            this.loggingIn = false;
            this.error = response.error?.message || response.error?.error || 'Invalid credentials. Please try again.';
          },
        });
      },
      error: (error) => {
        this.loggingIn = false;
        this.error = 'Unable to connect to the server. Please try again later.';
      }
    });
  }
}
